import React, { useMemo } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Form, FormGroup, Label, Input, FormFeedback, Button } from 'reactstrap';
import PropTypes from 'prop-types';
import { validateEmail } from '../../../../_helper/regexHandler';
import { useModalCrudState } from '../../../../_helper/hooks/useModalCrudState';

const ArbitratorDataModal = ({ apiEndpoint, isOpen, toggle, mode, selectedArbitrator, refreshData }) => {
    const initialArbitratorData = {
        id: '',
        fullName: '',
        email: '',
    };

    const validationSchema = useMemo(() => ({
        fullName: {
            required: true,
            message: 'Ad Soyad zorunludur.',
            minLength: 2,
            minLengthMessage: 'Ad Soyad en az 2 karakter olmalıdır.',
            minWords: 2,
            minWordsMessage: 'En az iki kelime girmelisiniz.',
        },
        email: {
            validator: validateEmail,
            validatorMessage: 'Geçerli bir e-posta adresi giriniz.',
        },
    }), []);

    const {
        formData: arbitratorData,
        errors,
        handleCancel,
        handleInputChange,
        handleSubmit,
        isSubmitting,
    } = useModalCrudState({
        isOpen,
        mode,
        selectedItem: selectedArbitrator,
        initialData: initialArbitratorData,
        toggle,
        normalizeInput: true,
        validationSchema,
        submitConfig: {
            apiEndpoint,
            selectedItem: mode === 'modify' ? { id: selectedArbitrator?.id } : null,
            refreshData,
            componentName: 'Hakem',
            buildPayload: (data) => ({
                fullName: data.fullName.trim(),
                email: data.email?.trim() || '',
                ...(mode === 'modify' && selectedArbitrator?.id && { id: selectedArbitrator.id }),
            }),
        },
    });

    const getModalTitle = () => {
        return mode === 'add' ? 'Hakem Ekle' : 'Hakem Düzenle';
    };

    const getButtonLabel = () => {
        return mode === 'add' ? 'Ekle' : 'Güncelle';
    };

    return (
        <Modal isOpen={isOpen} toggle={handleCancel} backdrop="static">
            <ModalHeader toggle={handleCancel}>{getModalTitle()}</ModalHeader>
            <ModalBody>
                <Form>
                    <FormGroup>
                        <Label for="fullName">Ad Soyad <span className="text-danger">*</span></Label>
                        <Input
                            type="text"
                            id="fullName"
                            name="fullName"
                            value={arbitratorData.fullName || ''}
                            onChange={handleInputChange}
                            placeholder="Hakem Ad Soyad"
                            invalid={!!errors.fullName}
                        />
                        <FormFeedback>{errors.fullName}</FormFeedback>
                    </FormGroup>
                    <FormGroup>
                        <Label for="email">E-posta</Label>
                        <Input
                            type="email"
                            id="email"
                            name="email"
                            value={arbitratorData.email || ''}
                            onChange={handleInputChange}
                            placeholder="ornek@sirket.com"
                            invalid={!!errors.email}
                        />
                        <FormFeedback>{errors.email}</FormFeedback>
                    </FormGroup>
                </Form>
            </ModalBody>
            <ModalFooter>
                <Button color="outline-success" className="rounded-pill" onClick={handleSubmit} disabled={isSubmitting}>
                    {isSubmitting ? 'Kaydediliyor...' : getButtonLabel()}
                </Button>
                <Button color="outline-danger" onClick={handleCancel} className="ms-2 rounded-pill">
                    İptal
                </Button>
            </ModalFooter>
        </Modal>
    );
};

ArbitratorDataModal.propTypes = {
    apiEndpoint: PropTypes.string.isRequired,
    isOpen: PropTypes.bool.isRequired,
    toggle: PropTypes.func.isRequired,
    mode: PropTypes.oneOf(['add', 'modify']).isRequired,
    selectedArbitrator: PropTypes.object,
    refreshData: PropTypes.func.isRequired,
};

export default ArbitratorDataModal;
